export class DirectionsSelectorTranslations {
  public heading?: string;

  constructor(obj: DirectionsSelectorTranslations = {}) {
    this.heading = obj.heading || 'Please select a map service.';
  }
}
